import { PaymentTrial } from '../../../models';

const getPaymentTrailsIdsLabel = (paymentTrials: PaymentTrial[]) => paymentTrials.reduce((acc: string, paymentTrial: PaymentTrial) => {
  if (acc.length === 0) return `${paymentTrial.trialId}`;
  return `${acc}, ${paymentTrial.trialId}`;
}, '');

export default getPaymentTrailsIdsLabel;
